// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Dashboard Layout === */
.dashboard {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f8fafc;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.dashboard-body {
  display: flex;
  flex-grow: 1;
}

.dashboard-content {
  flex-grow: 1;
  padding: 1rem 2rem;
  overflow-y: auto;
}

/* === Top Section Navigation === */
.section-nav {
  display: flex;
  gap: 1.5rem;
  padding: 1rem 20px;
  background: #f3f6f9;
  border-bottom: 1px solid #ccc;
  font-weight: 600;
  font-size: 0.95rem;
  color: #000000;
  position: sticky;
  top: 0;
  z-index: 999;
  border-radius: 20px;
}

.section-nav a {
  cursor: pointer;
  text-decoration: none;
  color: #000000;
  padding: 6px 10px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.section-nav a:hover {
  background-color: #000000;
  color: #ffffff;
}

/* === Emirate Filter Chips === */
.emirate-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin: 1rem 0 2rem;
}

.emirate-filter span {
  padding: 0.45rem 1.1rem;
  background: #e3e8ef;
  color: #333;
  border-radius: 999px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: 0.3s ease;
}

.emirate-filter span:hover {
  background: #ccd8e5;
}

.emirate-filter span.active {
  background: #000000;
  color: #fff;
  font-weight: 600;
}

/* === Section Headers === */
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  background: #ebe4df;
  padding: 0.85rem 1.25rem;
  border-left: 5px solid #ddd0c8;
  border-radius: 6px;
  font-size: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.section-header h2 {
  flex: 1 1;
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-header span {
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  color: #555;
}

/* === KPI Cards === */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 1.25rem;
  margin-top: 1rem;
}

.kpi-card {
  background: #f1ede8;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  border-left: 5px solid #2b2b2b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.kpi-card h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff; /* Updated from rgb(0, 64, 128) */
  margin-bottom: 6px;
}

.kpi-card p {
  font-size: 1.7rem;
  font-weight: bold;
  color: #ffffff;
  margin: 0.25rem 0;
}

.kpi-card small {
  font-size: 0.8rem;
  color: #555;
}

/* === AI Insights === */
.ai-insights-container {
  margin-top: 1rem;
  background-color: #f0f7ff;
  padding: 1rem;
  border-radius: 10px;
}

.insights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.insight-box {
  background: #ffffff;
  padding: 1rem;
  border-left: 4px solid #3f51b5;
  border-radius: 8px;
  font-size: 0.9rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.insight-box .alert-yellow {
  color: #c66900;
  font-weight: bold;
  display: inline-block;
}

.insight-box .alert-red {
  color: #b71c1c;
  font-weight: bold;
  display: inline-block;
}

.insight-box .ai-label {
  font-size: 0.75rem;
  background: #d0e3ff;
  padding: 2px 6px;
  margin-top: 0.5rem;
  display: inline-block;
  border-radius: 4px;
  color: #3a2e25;
}

/* === Risk Heatmap Table === */
.risk-heatmap {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.risk-heatmap th,
.risk-heatmap td {
  padding: 0.75rem;
  text-align: center;
}

.risk-heatmap th {
  background: #f1f5f9;
  color: #3a2e25;
}

.risk-low {
  background: #a7f3d0;
  color: #006644;
  font-weight: 600;
}

.risk-medium {
  background: #fde68a;
  color: #a86a00;
  font-weight: 600;
}

.risk-high {
  background: #fca5a5;
  color: #9b1c1c;
  font-weight: 600;
}

/* === Alerts and Notifications === */
.alert-card {
  background: #fff8e1;
  border-left: 4px solid #ff9800;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  font-size: 0.88rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.alert-card .icon {
  color: #ff9800;
  font-size: 1.3rem;
  margin-top: 2px;
}

.alert-title {
  font-weight: bold;
  color: #333;
}

.alert-meta {
  font-size: 0.75rem;
  color: #777;
}

/* === Section Collapsibility Toggle === */
.section-toggle {
  font-size: 1.2rem;
  font-weight: bold;
  color: #444;
  margin-left: auto;
  cursor: pointer;
}
.section-header {
  padding: 20px 20px 10px;
  background-color: #ebe4df;
  border-bottom: 1px solid #ddd;
}

.section-header h2 {
  font-size: 1.5rem;
  color: #000000; /* Warm brown aligned with MOEI branding */
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.section-header p {
  font-size: 0.95rem;
  color: #4d4d4d;
  margin-top: 0;
  line-height: 1.5;
}

.fal-chart-container {
  background: #fff;
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin: 20px;
}
/* === Colored KPI Cards === */
.kpi-card-1 {
  background-color: #2c7c9f;
  color: #ffffff;
  border-left: 5px solid #2c7c9f;
}

.kpi-card-2 {
  background-color: #f5b642;
  color: #ffffff;
  border-left: 5px solid #f5b642;
}

.kpi-card-3 {
  background-color: #cf4b5f;
  color: #ffffff;
  border-left: 5px solid #cf4b5f;
}

.kpi-card-4 {
  background-color: #2e8b57;
  color: #ffffff;
  border-left: 5px solid #2e8b57;
}

.kpi-card-5 {
  background-color: #3f86f6;
  color: #ffffff;
  border-left: 5px solid #3f86f6;
}

.kpi-card-6 {
  background-color: #7e57c2;
  color: #ffffff;
  border-left: 5px solid #7e57c2;
}

.kpi-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
}

.dashboard-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 0;
  background: #f5f7fb;
  border-bottom: 1px solid #dcdcdc;
}

.ai-actions {
  display: flex;
  gap: 0.75rem;
}

.ai-button {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background-color: #0061b0;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.ai-button:hover {
  background-color: #004a87;
}
.dashboard-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  gap: 1rem;
  flex-wrap: wrap;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0.5rem;
}

.section-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.nav-pill {
  background-color: #f4f4f4;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  font-size: 0.9rem;
  border: 1px solid #ccc;
  transition: all 0.2s ease-in-out;
}

.nav-pill:hover {
  background-color: #dbeeff;
  color: #004a87;
  border-color: #91c7f1;
}

.ai-actions {
  display: flex;
  gap: 0.75rem;
}

/* Base button styling */
.ai-button {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  padding: 0.45rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease-in-out;
}

/* Green primary button */
.ai-button.green {
  background-color: #1f6f45;
  color: #fff;
  box-shadow: 0 2px 6px rgba(31, 111, 69, 0.25);
}

.ai-button.green:hover {
  background-color: #155c3b;
  box-shadow: 0 3px 8px rgba(31, 111, 69, 0.4);
}

/* Violet outline button */
.ai-button.violet-outline {
  background-color: #fff;
  color: #6b1e8a;
  border: 1.5px solid #6b1e8a;
}

.ai-button.violet-outline:hover {
  background-color: #f7f0fa;
  color: #4e1365;
  border-color: #4e1365;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,iCAAiC;EACjD,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,0CAA0C;EAC1D,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;AACd;AACA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["/* === Dashboard Layout === */\n.dashboard {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #f8fafc;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.dashboard-body {\n  display: flex;\n  flex-grow: 1;\n}\n\n.dashboard-content {\n  flex-grow: 1;\n  padding: 1rem 2rem;\n  overflow-y: auto;\n}\n\n/* === Top Section Navigation === */\n.section-nav {\n  display: flex;\n  gap: 1.5rem;\n  padding: 1rem 20px;\n  background: #f3f6f9;\n  border-bottom: 1px solid #ccc;\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: #000000;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  border-radius: 20px;\n}\n\n.section-nav a {\n  cursor: pointer;\n  text-decoration: none;\n  color: #000000;\n  padding: 6px 10px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.section-nav a:hover {\n  background-color: #000000;\n  color: #ffffff;\n}\n\n/* === Emirate Filter Chips === */\n.emirate-filter {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  margin: 1rem 0 2rem;\n}\n\n.emirate-filter span {\n  padding: 0.45rem 1.1rem;\n  background: #e3e8ef;\n  color: #333;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: 0.3s ease;\n}\n\n.emirate-filter span:hover {\n  background: #ccd8e5;\n}\n\n.emirate-filter span.active {\n  background: #000000;\n  color: #fff;\n  font-weight: 600;\n}\n\n/* === Section Headers === */\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 2rem;\n  margin-bottom: 0.5rem;\n  background: #ebe4df;\n  padding: 0.85rem 1.25rem;\n  border-left: 5px solid #ddd0c8;\n  border-radius: 6px;\n  font-size: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.section-header h2 {\n  flex: 1;\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: #000000;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.section-header span {\n  font-size: 1.5rem;\n  font-weight: bold;\n  cursor: pointer;\n  color: #555;\n}\n\n/* === KPI Cards === */\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 1.25rem;\n  margin-top: 1rem;\n}\n\n.kpi-card {\n  background: #f1ede8;\n  padding: 1rem 1.25rem;\n  border-radius: 10px;\n  border-left: 5px solid #2b2b2b;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.kpi-card h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #ffffff; /* Updated from rgb(0, 64, 128) */\n  margin-bottom: 6px;\n}\n\n.kpi-card p {\n  font-size: 1.7rem;\n  font-weight: bold;\n  color: #ffffff;\n  margin: 0.25rem 0;\n}\n\n.kpi-card small {\n  font-size: 0.8rem;\n  color: #555;\n}\n\n/* === AI Insights === */\n.ai-insights-container {\n  margin-top: 1rem;\n  background-color: #f0f7ff;\n  padding: 1rem;\n  border-radius: 10px;\n}\n\n.insights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.insight-box {\n  background: #ffffff;\n  padding: 1rem;\n  border-left: 4px solid #3f51b5;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.insight-box .alert-yellow {\n  color: #c66900;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.insight-box .alert-red {\n  color: #b71c1c;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.insight-box .ai-label {\n  font-size: 0.75rem;\n  background: #d0e3ff;\n  padding: 2px 6px;\n  margin-top: 0.5rem;\n  display: inline-block;\n  border-radius: 4px;\n  color: #3a2e25;\n}\n\n/* === Risk Heatmap Table === */\n.risk-heatmap {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\n.risk-heatmap th,\n.risk-heatmap td {\n  padding: 0.75rem;\n  text-align: center;\n}\n\n.risk-heatmap th {\n  background: #f1f5f9;\n  color: #3a2e25;\n}\n\n.risk-low {\n  background: #a7f3d0;\n  color: #006644;\n  font-weight: 600;\n}\n\n.risk-medium {\n  background: #fde68a;\n  color: #a86a00;\n  font-weight: 600;\n}\n\n.risk-high {\n  background: #fca5a5;\n  color: #9b1c1c;\n  font-weight: 600;\n}\n\n/* === Alerts and Notifications === */\n.alert-card {\n  background: #fff8e1;\n  border-left: 4px solid #ff9800;\n  padding: 0.75rem 1rem;\n  margin-bottom: 0.5rem;\n  border-radius: 6px;\n  font-size: 0.88rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.alert-card .icon {\n  color: #ff9800;\n  font-size: 1.3rem;\n  margin-top: 2px;\n}\n\n.alert-title {\n  font-weight: bold;\n  color: #333;\n}\n\n.alert-meta {\n  font-size: 0.75rem;\n  color: #777;\n}\n\n/* === Section Collapsibility Toggle === */\n.section-toggle {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #444;\n  margin-left: auto;\n  cursor: pointer;\n}\n.section-header {\n  padding: 20px 20px 10px;\n  background-color: #ebe4df;\n  border-bottom: 1px solid #ddd;\n}\n\n.section-header h2 {\n  font-size: 1.5rem;\n  color: #000000; /* Warm brown aligned with MOEI branding */\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.section-header p {\n  font-size: 0.95rem;\n  color: #4d4d4d;\n  margin-top: 0;\n  line-height: 1.5;\n}\n\n.fal-chart-container {\n  background: #fff;\n  padding: 24px;\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  margin: 20px;\n}\n/* === Colored KPI Cards === */\n.kpi-card-1 {\n  background-color: #2c7c9f;\n  color: #ffffff;\n  border-left: 5px solid #2c7c9f;\n}\n\n.kpi-card-2 {\n  background-color: #f5b642;\n  color: #ffffff;\n  border-left: 5px solid #f5b642;\n}\n\n.kpi-card-3 {\n  background-color: #cf4b5f;\n  color: #ffffff;\n  border-left: 5px solid #cf4b5f;\n}\n\n.kpi-card-4 {\n  background-color: #2e8b57;\n  color: #ffffff;\n  border-left: 5px solid #2e8b57;\n}\n\n.kpi-card-5 {\n  background-color: #3f86f6;\n  color: #ffffff;\n  border-left: 5px solid #3f86f6;\n}\n\n.kpi-card-6 {\n  background-color: #7e57c2;\n  color: #ffffff;\n  border-left: 5px solid #7e57c2;\n}\n\n.kpi-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: all 0.2s ease-in-out;\n}\n\n.dashboard-top-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 0;\n  background: #f5f7fb;\n  border-bottom: 1px solid #dcdcdc;\n}\n\n.ai-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.ai-button {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  background-color: #0061b0;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.ai-button:hover {\n  background-color: #004a87;\n}\n.dashboard-top-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 0.5rem;\n}\n\n.section-nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.nav-pill {\n  background-color: #f4f4f4;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-weight: 500;\n  color: #333;\n  text-decoration: none;\n  font-size: 0.9rem;\n  border: 1px solid #ccc;\n  transition: all 0.2s ease-in-out;\n}\n\n.nav-pill:hover {\n  background-color: #dbeeff;\n  color: #004a87;\n  border-color: #91c7f1;\n}\n\n.ai-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n/* Base button styling */\n.ai-button {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.85rem;\n  padding: 0.45rem 1rem;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease-in-out;\n}\n\n/* Green primary button */\n.ai-button.green {\n  background-color: #1f6f45;\n  color: #fff;\n  box-shadow: 0 2px 6px rgba(31, 111, 69, 0.25);\n}\n\n.ai-button.green:hover {\n  background-color: #155c3b;\n  box-shadow: 0 3px 8px rgba(31, 111, 69, 0.4);\n}\n\n/* Violet outline button */\n.ai-button.violet-outline {\n  background-color: #fff;\n  color: #6b1e8a;\n  border: 1.5px solid #6b1e8a;\n}\n\n.ai-button.violet-outline:hover {\n  background-color: #f7f0fa;\n  color: #4e1365;\n  border-color: #4e1365;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
